// The two colours of the review scan, shared by the minimap and the on-slide
// layer so the same thing looks the same in both places. Emerald is the
// navigator's "seen" colour. The plan is dark dashes on a light halo: plain
// white vanished on white glass, which is exactly where a tissue outline sits.

import type { Rgba } from './coverage';

export const PLAN_STROKE = 'rgba(15,23,42,0.85)';
export const PLAN_HALO = 'rgba(255,255,255,0.75)';
/** emerald-400 at 35%. */
export const COVER_FILL: Rgba = [52, 211, 153, 89];
export const COVER_STROKE = 'rgba(52,211,153,0.9)';
